import { useQuery } from '@tanstack/react-query';
import { getProducts } from '../../api/apiProducts';
import i18next from 'i18next';

/**
 * Hook to fetch products with pagination and filters
 */
export const useGetProducts = (params = {}) => {
    const {
        data,
        error,
        isLoading,
        refetch,
        isFetching
    } = useQuery({
        queryKey: ['products', params, i18next.language],
        queryFn: () => getProducts(params),
        retry: false,
    });

    return {
        products: data?.data || [],
        meta: data?.meta || {},
        error,
        isLoading,
        isFetching,
        refetch
    };
};
